import React, { useEffect, useLayoutEffect } from "react";
import { api } from "../api/api";
import { DataContext, useDataContext } from "../core/hooks/useData"
import { Page } from "../pages/Page"
import { Presenter, getPresenter, prepareFormDef } from "./Presenter"
import { account_form, form_def } from "../types";
import { useApi } from "../core/hooks/useApi";
import { Outline } from "./Outline";
import { broadcast } from "../core/hooks/useChannel";
import { PresenterMessages } from "./types";
import { useLocalStorage } from "../core/hooks/useLocalStorage";
import { getFirstObjectValue } from "../core/utils/objectPath";
import { go } from "../core/route/Route";
import { Icon } from "../core/ui/icons";

export function Form(props: {
	id: string,
}) {

	const data = useDataContext({
		initialValue: {} as any,
	});

	data.customValidate = () => {
		console.dir(data.value);
	};

	const [defaults, setDefaults] = useLocalStorage<any>("defaults");
	const [account] = useLocalStorage<any>("account");

	useEffect(() => {
		// check if we have the user defaults already cached locally
		if (!defaults) {
			api.user_defaults().then((result) => {
				const presenter = getPresenter(props.id);
				if (presenter) presenter.defaults = result;
				setDefaults(result);

			}).catch((e) => {

			});
		}

	}, [defaults]);

	const combinedDefaults = {
		...(defaults ? defaults : {}),
		...(account ? account : {}),
	};

	const form = useApi<account_form>({
		request: () => api.account_form_with_def({ 
			id: props.id,
			
			// want pricing info too
			additional_refs: [
				"pricing-diy",
				"pricing-review"
			]
		}),
		prepareResult: (result) => {
			prepareFormDef(result.def.data, result.subForms);
			return result;
		}
	}, [props.id]);

	if (!form) return null;

	return (
		<Page
			padding={false}
		>
			<DataContext.Provider value={data}>
			

				<div className="flex horiz align-start bg-brand-primary">
					<div className="outline-container width-25vw text-inverse ">
						<Outline 
							presenterID={props.id}
						/>
					</div>

					<div
						id={props.id + "-container"}
						className="presenter-container width-75vw bg padding-20"
						style={{"overflow":"scroll", "height": "100vh"}} //calc(100vh - 70px)

						onScroll={(e: any) => {
							broadcast(props.id, {
								type: PresenterMessages.SCROLL,
								scrollTop: e.target.scrollTop,
							})
						}}
					>
						<div className="flex vert not-desktop"><Icon type="logo" size="logo-med" /></div>
		
						<Presenter
							id={props.id}

							//readOnly={true}

							def={(form.def as form_def).data}
							refs={form.refs}
							formValues={form.data}
							subForms={form.subForms}
							reports={form.reports!}
							title={form.title}

							defaults={combinedDefaults}

							onSetGeneratedData={(name, data) => {
								if (!form.generatedData) form.generatedData = {};
								form.generatedData[name] = data;
							}}

							onSave={(props) => {


								// look for values which can be used as defaults for future forms
								const d = {
									package: getFirstObjectValue(props.formValues, "package"),
								} as any;
								let updateDefaults = false;
								if (defaults) {
									for(let m in d) {
										const thisVal = d[m];
										const prevVal = defaults[m];
										if (thisVal && !prevVal && thisVal !== prevVal) {
											defaults[m] = thisVal;
											updateDefaults = true;
										}
									}
								}
								if (updateDefaults) {
									api.user_set_defaults(defaults).then((latestDefaults) => {
										setDefaults(latestDefaults);
										doSave();
									}).catch((e) => {

									});

								} else {
									doSave();
								}
								
								function doSave() {
									api.account_form_update({
										id: form!.id,
										data: props.formValues,
										generatedData: form!.generatedData,
										title: props.title,
									}).then(() => {
										go("/dashboard/");
					
									}).catch(() => {
					
									});	
								}

							}}
						>
						</Presenter>
						<div style={{height:"75vh"}}>
						</div>
					</div>
				</div>


			</DataContext.Provider>
		</Page>
	)
	
}